import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Frequently Asked Questions", -1)
const _hoisted_2 = { clasS: "tw-text-primary tw-font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, (f) => {
        return (_openBlock(), _createElementBlock("li", {
          key: f.id,
          class: "tw-mb-4"
        }, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(f.question), 1),
          _createElementVNode("div", null, _toDisplayString(f.answer), 1)
        ]))
      }), 128))
    ])
  ]))
}